import React from 'react';

interface NewsBodyProps {
  title: string;
  content?: string;
  showContent?: boolean;
  titleClassName?: string;
  contentClassName?: string;
}

const NewsBody: React.FC<NewsBodyProps> = ({
  title,
  content,
  showContent = false,
  titleClassName = '',
  contentClassName = '',
}) => {
  return (
    <div>
      <h3 className={`font-normal text-[14px] md:text-[16px] text-[#1A1A1A] line-clamp-2 leading-[18px] ${titleClassName}`}>
        {title}
      </h3>
      {showContent && content && (
        <p className={`text-xs text-gray-600 leading-[1.4] line-clamp-3 ${contentClassName}`}>
          {content}
        </p>
      )}
    </div>
  );
};

export default NewsBody;

